export default __webpack_public_path__ + "static/media/search-for.b0e493ea.svg";